import React from 'react'
import './Myskills.css'
function Myskills() {
  return (
    <div >
      <div className='hero-img5'>
      <div className="heading">
        <h1>Skills</h1>
        <p className='animation5'>What skills i have.</p>
       
      </div>
      </div>
     
    </div>
  )
}

export default Myskills